import { cn } from "@/libs/cn";
import { Button, Form, message, Upload } from "antd";
import { UploadChangeParam } from "antd/es/upload";
import { AiFillFileImage, AiOutlinePlus } from "react-icons/ai";
import { PostImage } from ".";

export function ImageUploadFormItem({
    images,
    onImageChange,
    variant = "default"
}: {
    images: PostImage[];
    onImageChange: (info: UploadChangeParam) => void;
    variant?: "default" | "add-more" | "edit-add-more";
}) {

    return (
        <>
            <Form.Item
                name={"uploadedImages"}
                noStyle
            >
                <Upload
                    accept="image/png, image/jpeg, image/jpg, image/webp"
                    maxCount={10}
                    multiple
                    fileList={images.map(img => img.file)}
                    beforeUpload={(file, filelist) => {
                        const totalImages = images.length + filelist.length;
                        if (totalImages > 10) {
                            message.warning("You can only upload up to 10 images.");
                            // return Upload.LIST_IGNORE;
                        }
                        return false;
                    }} // Prevent auto upload
                    showUploadList={false}
                    onChange={onImageChange}
                >
                    <Button
                        icon={
                            variant === "default" ? <AiFillFileImage /> : <AiOutlinePlus />
                        }
                        type={"default"}
                        className={cn("!font-poppins !border-none !shadow-none", {
                            "!px-1 bg-transparent": variant === "default",
                            "!bg-white opacity-80 hover:opacity-100 !rounded-md": variant === "add-more",
                            "hover:!bg-black/10 !text-2C": variant === "edit-add-more"
                        })}
                        shape={variant === "edit-add-more" ? "round" : "default"}
                        size={variant === "add-more" ? "middle" : "large"}
                    >
                        {
                            variant === "default" ? "Upload" : "Add more images"
                        }
                    </Button>
                </Upload>
            </Form.Item>
        </>
    )
}
